import { render, staticRenderFns } from "./ModalDownload.vue?vue&type=template&id=0070717c&scoped=true&"
import script from "./ModalDownload.vue?vue&type=script&lang=js&"
export * from "./ModalDownload.vue?vue&type=script&lang=js&"
import style0 from "./ModalDownload.vue?vue&type=style&index=0&id=0070717c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0070717c",
  null
  
)

export default component.exports